import { navigateToUrl } from 'single-spa';
import { toSurePartUrl } from '../../surepart-routing';
import styles from './footer.module.css';

const rawEnv = import.meta.env as Record<string, unknown>;
const appVersion = typeof rawEnv.VITE_APP_VERSION === 'string' ? rawEnv.VITE_APP_VERSION : 'dev';

class FooterSection extends HTMLElement {
    public connectedCallback(): void {
        this.render();
        this.attachEventListeners();
    }

    public render(): void {
        this.innerHTML = `
            <div class="${styles.footerSection}">
                <div class="${styles.container}">
                    <div class="${styles.links}">
                        <a href="${toSurePartUrl('/')}" data-nav-link>Home</a>
                        <a href="${toSurePartUrl('/contactus')}" data-nav-link>Contact Us</a>
                    </div>
                    <div class="${styles.logo}">
                        <img width="151" src="/logo-pt.png" alt="Partstrader Logo" />
                    </div>
                </div>
                <div class="${styles.copyright}">
                    <p>© ${new Date().getFullYear().toString()} PARTSTRADER | ALL RIGHTS RESERVED | SUREPART v${appVersion}</p>
                </div>
            </div>
        `;
    }

    public attachEventListeners(): void {
        const navLinks = this.querySelectorAll<HTMLAnchorElement>('[data-nav-link]');
        // oxlint-disable-next-line unicorn/prefer-spread -- NodeListOf requires conversion for TypeScript iteration
        for (const link of Array.from(navLinks)) {
            link.addEventListener('click', (event: MouseEvent) => {
                event.preventDefault();
                const href = link.getAttribute('href');
                if (href) {
                    navigateToUrl(href);
                }
            });
        }
    }
}

// Register the custom element
customElements.define('footer-section', FooterSection);

export { FooterSection };
